import { render, staticRenderFns } from "./project-tab.vue?vue&type=template&id=23a630c3&scoped=true"
import script from "./project-tab.vue?vue&type=script&lang=js"
export * from "./project-tab.vue?vue&type=script&lang=js"
import style0 from "./project-tab.vue?vue&type=style&index=0&id=23a630c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a630c3",
  null
  
)

export default component.exports